import { render, staticRenderFns } from "./AlternativeDashboard.vue?vue&type=template&id=78ef53c1&scoped=true&"
import script from "./AlternativeDashboard.vue?vue&type=script&lang=js&"
export * from "./AlternativeDashboard.vue?vue&type=script&lang=js&"
import style1 from "./AlternativeDashboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ef53c1",
  null
  
)

export default component.exports